import React, { useState } from 'react';
import {
  Col,
  Row,
  Button,
  Card,
  Form,
  Modal,
  Tabs,
  Tab,
  Spinner,
  ListGroup
} from 'react-bootstrap';
import PageHeader from 'components/common/PageHeader';
import UserDropdownV2 from 'components/dropdowns/CustomerServices/UserDropdownV2';
import {
  useUploadByRecordValue,
  useDownloadByTraineeFiles
} from 'hooks/useHandleS3File';
import { SMTrainingDocRecordApp } from '../create-record/RecordDocumentModal';
import { S3_SM_TRANNING_DOC_FOLDER } from 'helpers/urlHelper';

const SMTrainingDocUsersApp = 'sm.training.doc.users';

export default function TrainneeDocument() {
  const [filter, setFilter] = useState({ startDate: new Date() });

  const {
    uploadedFiles,
    isLoading,
    itemDownLoading,
    itemDeleting,
    fileInputRef,
    handleFileChange,
    handleUpload,
    onFileDownload,
    onFileDelete,
    onFilePrint
  } = useUploadByRecordValue(
    S3_SM_TRANNING_DOC_FOLDER + `/Users/${filter?.trainee}`,
    `${filter?.trainee}`,
    SMTrainingDocUsersApp
  );
  const {
    onFileDownload: onRecordFileDownload,
    uploadedFiles: uploadedRecordFiles
  } = useDownloadByTraineeFiles(
    `${S3_SM_TRANNING_DOC_FOLDER}/Records`,
    filter?.trainee,
    SMTrainingDocRecordApp
  );

  const handleFilterChange = (key, value) => {
    console.log(key, value);
    switch (key) {
      case 'trainee':
        setFilter({ ...filter, trainee: value.userId });
        break;
      default:
        filter[key] = value;
        setFilter({ ...filter });
        break;
    }
  };

  return (
    <>
      <Row>
        <Col xs={12}>
          <PageHeader
            title={"Trainee's Document"}
            description={``}
            className="mb-3"
            col={{ lg: 12 }}
          ></PageHeader>
        </Col>
        <Col xs={12}>
          <Col lg={12}>
            <Row className="g-3 mb-3">
              <Card className="mb-3">
                <Card.Body className="bg-light">
                  <Row style={{ paddingBottom: '10px' }}>
                    <Col md="3">
                      <Form.Group>
                        <Form.Label>Trainee</Form.Label>
                        <UserDropdownV2
                          disabled={filter?.id > 0}
                          fieldName="trainee"
                          isMulti={false}
                          handleChange={handleFilterChange}
                          placeholder="Trainee"
                          value={filter?.trainee}
                          closeMenuOnSelect={true}
                          useDepartment={true}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Row>

            <Row className="g-3 mb-3">
              <Card show={true} contentClassName="border" size="lg">
                <Form onSubmit={() => {}}>
                  <Card.Header
                    closeButton
                    className="bg-light px-card border-bottom-0"
                  >
                    <Card.Title as="h5">File Management</Card.Title>
                  </Card.Header>
                  <Modal.Body className="p-card">
                    <Tabs
                      defaultActiveKey="user-files"
                      id="file-management-tabs"
                      className="mb-3"
                    >
                      {filter?.trainee > 0 && (
                        <Tab
                          eventKey="user-files"
                          title={`User Files (${uploadedFiles?.length})`}
                        >
                          {/* File Upload Section */}
                          <Form.Group className="mb-3" controlId="fileInput">
                            <Form.Label className="fs-0 required">
                              Upload File
                            </Form.Label>
                            <Form.Control
                              type="file"
                              name="file"
                              onChange={handleFileChange}
                              ref={fileInputRef}
                            />
                            {isLoading ? (
                              <Spinner
                                variant="primary"
                                animation="border"
                                role="status"
                                className="mt-2"
                              />
                            ) : (
                              <Button
                                variant="secondary"
                                onClick={handleUpload}
                                className="mt-2"
                                // disabled={false}
                              >
                                Upload
                              </Button>
                            )}
                          </Form.Group>

                          {/* User Files List */}
                          {uploadedFiles?.length > 0 ? (
                            <Form.Group className="mb-3">
                              <Form.Label className="fs-0">
                                Uploaded User Files
                              </Form.Label>
                              <ListGroup>
                                {uploadedFiles?.map((file, index) => (
                                  <ListGroup.Item
                                    key={index}
                                    className="d-flex justify-content-between align-items-center"
                                  >
                                    <span>{file.name}</span>
                                    <div className="d-flex align-items-center">
                                      {itemDeleting === index ? (
                                        <Spinner
                                          variant="primary"
                                          animation="border"
                                          role="status"
                                          className="me-2"
                                        />
                                      ) : (
                                        <Button
                                          variant="danger"
                                          size="sm"
                                          className="me-2"
                                          onClick={() => onFileDelete(index)}
                                        >
                                          Delete
                                        </Button>
                                      )}
                                      {itemDownLoading === index ? (
                                        <Spinner
                                          variant="primary"
                                          animation="border"
                                          role="status"
                                          className="me-2"
                                        />
                                      ) : (
                                        <Button
                                          variant="primary"
                                          size="sm"
                                          className="me-2"
                                          onClick={() =>
                                            onFileDownload(index, uploadedFiles)
                                          }
                                        >
                                          Download
                                        </Button>
                                      )}

                                      <Button
                                        variant="primary"
                                        size="sm"
                                        onClick={() => onFilePrint(index)}
                                      >
                                        Print
                                      </Button>
                                    </div>
                                  </ListGroup.Item>
                                ))}
                              </ListGroup>
                            </Form.Group>
                          ) : (
                            <p className="text-muted">
                              No user files uploaded yet.
                            </p>
                          )}
                        </Tab>
                      )}

                      {filter?.trainee > 0 && (
                        <Tab
                          eventKey="record-files"
                          title={`Record Files (${uploadedRecordFiles?.length})`}
                        >
                          {/* Record Files List */}
                          {uploadedRecordFiles?.length > 0 ? (
                            <Form.Group className="mb-3">
                              <Form.Label className="fs-0">
                                Uploaded Record Files
                              </Form.Label>
                              <ListGroup>
                                {uploadedRecordFiles?.map((file, index) => (
                                  <ListGroup.Item
                                    key={index}
                                    className="d-flex justify-content-between align-items-center"
                                  >
                                    <span>{file.name}</span>
                                    <div className="d-flex align-items-center">
                                      {itemDownLoading === index ? (
                                        <Spinner
                                          variant="primary"
                                          animation="border"
                                          role="status"
                                          className="me-2"
                                        />
                                      ) : (
                                        <Button
                                          variant="primary"
                                          size="sm"
                                          onClick={() =>
                                            onRecordFileDownload(
                                              index,
                                              uploadedRecordFiles
                                            )
                                          }
                                        >
                                          Download
                                        </Button>
                                      )}
                                    </div>
                                  </ListGroup.Item>
                                ))}
                              </ListGroup>
                            </Form.Group>
                          ) : (
                            <p className="text-muted">
                              No record files available.
                            </p>
                          )}
                        </Tab>
                      )}
                    </Tabs>
                  </Modal.Body>
                </Form>
              </Card>
            </Row>
          </Col>
        </Col>
      </Row>
    </>
  );
}
